/**
 * The `bucket` tag every cache metric is sliced by. Shared so that eviction
 * counts and the size census describe the same buckets and can be read on one
 * graph — cache names include workbox's hashed precache names, so this matches
 * on substrings rather than exact names.
 */
function cacheBucket(cacheName: string): string {
  if (cacheName.includes("video")) return "video";
  if (cacheName.includes("image")) return "image";
  if (cacheName.includes("font")) return "font";
  if (cacheName.includes("precache")) return "precache";
  if (cacheName.includes("content")) return "content";
  return "other";
}

export { cacheBucket };
